const messages = {
    providerPaymentPeriods: 'Provider payment periods',
    providerPaymentPeriodsSubtitle:
        'Manage the current draft and review past payment periods for external providers.',
    newProviderPaymentPeriod: 'New payment period',
    createPaymentPeriod: 'Create payment period',
    providerPaymentPeriodCreated: 'Provider payment period created successfully',
    currentDraft: 'CURRENT DRAFT',
    pastPeriods: 'Past periods',
    paymentStatusCounts: 'Payment status counts',
    draftCount: 'Draft',
    reviewCount: 'Review',
    printedCount: 'Printed',
    noProviderPaymentPeriods: 'No payment periods yet',
    noProviderPaymentPeriodsHint:
        'Create the first payment period to start tracking provider payments.',
    errorLoadingProviderPaymentPeriods: 'Error loading provider payment periods',
    unauthorizedProviderPaymentPeriods:
        "You don't have authorization to view provider payment periods",
    unauthorizedCreateProviderPaymentPeriod:
        "You don't have authorization to create a provider payment period",
    // Draft checklist page
    viewDraftChecks: 'View draft checks',
    loading: 'Loading',
    errorLoadingDraftChecks: 'Error loading draft checks',
    backToPaymentPeriods: 'Back to payment periods',
    draftChecklist: 'Draft checklist',
    draftChecklistSubtitle: 'Review and manage the checks included in this payment period draft.',
    addOneOffCheckUnavailable: 'One-off check creation is not yet available',
    addOneOffCheck: 'Add one-off check',
    draftSummary: 'Draft summary',
    checks: 'checks',
    totalAmount: 'Total amount',
    noDraftChecks: 'No draft checks yet',
    noDraftChecksHint: 'Auto-populated checks will appear here. You can also add one-off checks.',
    draftChecklistTableLabel: 'Draft checks table',
    unauthorizedDraftChecks: "You don't have authorization to view draft checks",
    // Draft check row actions (#1695)
    editCheck: 'Edit check',
    deleteCheck: 'Delete check',
    sendToReview: 'Send to review',
    // Edit draft check slide-over
    editDraftCheck: 'Edit draft check',
    editDraftCheckDescription: 'Update the amount or memo for this draft check.',
    checkUpdatedSuccessfully: 'Check updated successfully',
    errorUpdatingCheck: 'Error updating check',
    // Delete confirmation
    deleteCheckTitle: 'Delete draft check',
    deleteCheckText: 'Are you sure you want to delete this check? This action cannot be undone.',
    checkDeletedSuccessfully: 'Check deleted successfully',
    errorDeletingCheck: 'Error deleting check',
    // Send to review confirmation
    sendToReviewTitle: 'Send check to review',
    sendToReviewText: 'This check will be moved from Draft to Review. Do you want to proceed?',
    checkSentToReviewSuccessfully: 'Check sent to review successfully',
    errorSendingCheckToReview: 'Error sending check to review',
    unauthorizedOneOffCheck: "You don't have authorization to create one-off checks",
    // Returned for edits chip — shown in Draft row when check was returned from Review (#1698)
    returnedForEdits: 'Returned for edits',
    // One-off check modal (Story #1697)
    addOneOffCheckTitle: 'Add one-off check',
    addOneOffCheckDescription:
        'Create a one-off check for an existing provider or a new inline provider.',
    providerType: 'Provider type',
    providerPathExisting: 'Existing provider',
    providerPathInline: 'New inline provider',
    searchProvider: 'Provider',
    searchProviderPlaceholder: 'Type to search providers...',
    searchProviderResults: 'Provider search results',
    clearSelection: 'Clear selection',
    inlineProviderName: 'Provider name',
    inlineProviderCategory: 'Provider category',
    selectCategory: '— Select category —',
    duplicateProviderWarning: 'A similar provider already exists',
    oneOffCheckCreatedSuccessfully: 'One-off check created successfully',
    selectProvider: 'Please select a provider',
    fieldRequired: 'This field is required',
    maxLength200: 'Must be 200 characters or fewer',
    // Bulk send-to-review (#1696 / #1762)
    selected: 'selected',
    selectAllChecks: 'Select all checks',
    selectCheck: 'Select check',
    bulkSendToReview: 'Send selected to Review',
    bulkSendToReviewTitle: 'Send selected checks to review',
    bulkSendToReviewText:
        'The selected checks will be moved from Draft to Review. Do you want to proceed?',
    bulkBarAriaLabel: 'Bulk action bar',
    // Bulk send-to-review outcomes (#1762)
    bulkSentToReviewCount: '{count} checks sent to review successfully',
    bulkPartialFailureTitle: 'Some checks could not be sent to review',
    bulkPartialFailureMessage:
        '{succeeded} of {total} checks sent to review. {failed} could not be processed and remain selected for retry.',
    bulkFullFailureTitle: 'No checks could be sent to review',
    bulkFullFailureMessage:
        'All {count} selected checks failed to be sent to review. They remain selected for retry.',
    // Review queue page (Story #1698)
    viewReviewChecks: 'View review checks',
    errorLoadingReviewChecks: 'Error loading review checks',
    reviewChecklist: 'Review checklist',
    reviewChecklistSubtitle:
        'Checks promoted to Review. Return unprinted checks to Draft if edits are needed.',
    reviewSummary: 'Review summary',
    noReviewChecks: 'No checks in review',
    noReviewChecksHint: 'Checks sent to review from the draft list will appear here.',
    reviewChecklistTableLabel: 'Review checks table',
    unauthorizedReviewChecks: "You don't have authorization to view review checks",
    checkNumber: 'Check #',
    printed: 'Printed',
    // Return to Draft action (PAC.12.06)
    returnToDraft: 'Return to Draft',
    returnToDraftTitle: 'Return check to Draft',
    returnToDraftText:
        'This check will be moved from Review back to Draft for editing. Do you want to proceed?',
    checkReturnedToDraftSuccessfully: 'Check returned to Draft successfully',
    errorReturningCheckToDraft: 'Error returning check to Draft',
    // Tooltip shown on disabled Return-to-Draft action for printed checks
    printedCannotBeReturned: 'Printed checks cannot be returned.',
    // Print selected checks — selection action bar (#1699)
    selectionActionBarAriaLabel: 'Selection action bar',
    printSelectedChecks: 'Print selected checks',
    printedCheckCannotBeReprinted: 'Already-printed checks cannot be reprinted from preview.',
    unauthorizedPrintPreview: "You don't have authorization to print a payroll preview.",
    // Print selected checks — dialog (#1699)
    checkNumbersAssignedRange: 'Check numbers that will be assigned: {from} \u2013 {to}',
    payDateRequired: 'Pay date is required.',
    payDateTooFarFuture: 'Pay date cannot be more than 1 year in the future.',
    startingCheckNumberRequired: 'Starting check number is required.',
    startingCheckNumberOutOfRange: 'Starting check number must be between 1 and 9,999,999.',
    generating: 'Generating...',
    generatePdf: 'Generate PDF',
    payDateLabel: 'Pay date',
    payDateHelp: 'Date that will appear on each printed check.',
    startingCheckNumberLabel: 'Starting check number',
    startingCheckNumberHelp: 'First number to assign to the selection.',
    startingCheckNumberPlaceholder: 'e.g. 1042',
    mutationSafeNotice:
        'Generating the PDF will not mark these checks as printed. You will confirm after a successful print.',
    errorGeneratingPdf: 'Could not generate the PDF.',
    errorGeneratingPdfDetail: 'No checks were modified. Please retry.',
    retry: 'Retry',
    rangeLabel: 'Range',
    required: 'required',
    // Awaiting-confirmation dialog (#1700)
    awaitingConfirmationTitle: 'Did the checks print correctly?',
    awaitingConfirmationBody:
        'The PDF has been generated. Inspect the printout, then confirm so the system can record these checks as printed.',
    reDownloadPdf: 'Re-download PDF',
    yesMarkAsPrinted: 'Yes, mark as printed',
    confirming: 'Confirming...',
    checksConfirmedAsPrinted: 'Checks confirmed as printed.',
    errorConfirmingPrinted: 'Could not confirm the checks as printed.',
    printPreviewClosedNoChanges: 'Print preview closed. No data was changed.',
    // Close Period panel (US #1701)
    closePeriod: 'Close period',
    closingPeriod: 'Closing...',
    closePeriodTitle: 'Close payment period',
    closePeriodText:
        'This will permanently close the payment period. No further changes will be allowed. Do you want to proceed?',
    closePeriodSuccess: 'Payment period closed successfully',
    errorClosingPeriod: 'Error closing payment period',
    closePeriodBlockersTitle: 'Settlement blockers',
    closePeriodBlockersDraftSingular: '1 check remains in Draft',
    closePeriodBlockersDraftPlural: '{n} checks remain in Draft',
    closePeriodBlockersReviewSingular: '1 Review check is not printed',
    closePeriodBlockersReviewPlural: '{n} Review checks are not printed',
    closePeriodEligible: 'All checks are settled. The period is ready to close.',
    unauthorizedClosePeriod: "You don't have authorization to close this payment period",
};

export default messages;
